export default __webpack_public_path__ + "static/media/star.18bb1786.svg";